import { string, func, shape } from 'prop-types'
import keyPress from '../../../utilities/keyPress.js'

import Icon from '../../icon/index.js'

function IconButton({ ariaLabel, className, onClick, iconName, iconColor, style = {} }) {
  return (
    <div
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      onKeyDown={(e) => {
        keyPress(e, () => onClick(e))
      }}
      role="button"
      style={style}
      tabIndex={0}
    >
      <Icon color={iconColor} icon={iconName} />
    </div>
  )
}

IconButton.propTypes = {
  ariaLabel: string.isRequired,
  className: string.isRequired,
  iconColor: string,
  iconName: string.isRequired,
  onClick: func.isRequired,
  style: shape(),
}

export default IconButton
